import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLike, meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {LabelPrimitivesOperatorParameters} from "#template/nodes/geometry-graph/attribute/label-primitives-operator/geometry-label-primitives-operator-node"
import {
    GeometryLabelPrimitivesOperatorNode,
    labelPrimitivesOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/label-primitives-operator/geometry-label-primitives-operator-node"

export type MeshGeometryLabelPrimitivesOperatorParameters = LabelPrimitivesOperatorParameters<MeshGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryLabelPrimitivesOperatorParameters> = {
    nodeClass: "MeshGeometryLabelPrimitivesOperator",
    validation: {
        parameters: labelPrimitivesOperatorParametersSchema(meshGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryLabelPrimitivesOperator
    extends GeometryLabelPrimitivesOperatorNode<2, MeshGeometryAttributeLikeNode>
    implements MeshGeometryAttributeLikeNode
{
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
